import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aa6e787"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "conter",
  style: {"gap":"60px"}
}
const _hoisted_2 = { class: "flex-ct header-box web" }
const _hoisted_3 = { class: "flex-ct header-box h5" }
const _hoisted_4 = {
  key: 0,
  class: "qa-box"
}
const _hoisted_5 = { class: "q" }
const _hoisted_6 = { class: "flex-ct a" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "remark"
}
const _hoisted_9 = {
  key: 0,
  class: "flex-ct foot"
}
const _hoisted_10 = {
  key: 1,
  class: "r-box"
}
const _hoisted_11 = { class: "r" }
const _hoisted_12 = { class: "flex-ct title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", null, "Results Evaluation", -1))
const _hoisted_14 = { class: "content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "Further matching tests are needed to determine whether you are compatible with your relatives.", -1))

import { Image } from "vant";
import { ref } from "vue";
import { QAList } from "./config";
import IconTip from "@/assets/icon/result222.png";
import IconTip2 from "@/assets/icon/result2222.png";
import HeadBg from "@/assets/icon/head222EN.png";
import HeadBgH5 from "@/assets/icon/head222H5EN.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const is_q = ref(true); // 问题还是结果展示
const init_q = Object.assign(
  { select_r: undefined as undefined | number, current_q: "q1" },
  QAList.q1
);
const qa_history = ref([init_q]); //问题列表
const current_q = ref("q1"); //当前问题
const current_a = ref<undefined | number>(undefined); //当前答案

//重新测试
function reTest() {
  qa_history.value = [init_q];
  current_q.value = "q1";
  is_q.value = true;
}
//上一题
function beforeQ() {
  if (current_q.value === "q1") {
    return;
  }
  current_q.value = qa_history.value.at(-1)!.current_q;
  qa_history.value.pop();
  current_a.value = qa_history.value.at(-1)!.select_r;
}
// 下一题
function nextQ(r: any, index: number) {
  qa_history.value.at(-1)!.select_r! = index;
  const result = Object.assign(
    { select_r: undefined, current_q: current_q.value },
    r
  );
  qa_history.value.push(result);

  current_q.value = r.result; // 记录下一题问题
  current_a.value = undefined;
  if (r.result.includes("r")) {
    is_q.value = false;
  }
}
// 新页面打开网站
function openHome() {
  window.open("https://www.transplantation.com.cn/en_US/");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Image), {
        onClick: openHome,
        src: _unref(HeadBg),
        width: "900px"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Image), {
        onClick: openHome,
        src: _unref(HeadBgH5),
        width: "100%"
      }, null, 8, ["src"])
    ]),
    (is_q.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(QAList)[current_q.value].q), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(QAList)[current_q.value].a_list, (item, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                class: _normalizeClass(
            current_a.value === index ? 'flex-ct a-btn active' : 'flex-ct a-btn'
          ),
                onClick: ($event: any) => (nextQ(item, index))
              }, [
                _createElementVNode("span", null, _toDisplayString(item.a), 1),
                (item.remark)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.remark), 1))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_7))
            }), 128))
          ]),
          (current_q.value !== 'q1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "next-btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (beforeQ()))
                }, "Previous"),
                _createElementVNode("button", {
                  class: "next-btn",
                  onClick: openHome
                }, "End of test")
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_unref(Image), {
                src: _unref(QAList)[current_q.value].type === 'success' ? _unref(IconTip) : _unref(IconTip2),
                width: "48px"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(QAList)[current_q.value].r), 1),
            _hoisted_15
          ]),
          _createElementVNode("div", { class: "flex-ct foot" }, [
            _createElementVNode("button", {
              class: "next-btn",
              onClick: openHome
            }, "Return to website"),
            _createElementVNode("button", {
              class: "next-btn",
              onClick: reTest
            }, "Retest")
          ])
        ]))
  ]))
}
}

})